import BaseService from "./base.service";
const service = new BaseService("/divalto_codes")

service.import = function(payload, config){
  const path = this._getResource() + '/import'
  return this.http.post(path, payload, config);
}

service.updateCode = function(id, payload) {
  const path = this._getResource() + `/${id}`;
  return this.http.put(path, payload );
};

service.createCode = function(payload){
  const path = this._getResource();
  return this.http.post(path, payload);
};

service.deleteCode = function(id, config) {
  const path = `${this._getResource()}/${id}`;
  return this.http.delete(path, config);
};

service.bulkDeleteCodes = function(ids, config) {
  const path = this._getResource() + '/bulk_delete';
  return this.http.post(path, { ids }, config);
};


export default service;
